import { StateCreator } from 'zustand';

export interface SideBarStore {
  sidebar: {
    isOpen: boolean;
    toggle: () => void;
    open: () => void;
    close: () => void;
    setValue: (value: boolean) => void;
  };
}

export const getSideBarStore: StateCreator<
  SideBarStore,
  [['zustand/devtools', never]]
> = set => ({
  sidebar: {
    isOpen: false,
    toggle: () =>
      set(
        state => ({
          ...state,
          sidebar: {
            ...state.sidebar,
            isOpen: !state.sidebar.isOpen,
          },
        }),
        false,
        'sidebar/toggle',
      ),
    open: () =>
      set(
        state => ({ ...state, sidebar: { ...state.sidebar, isOpen: true } }),
        false,
        'sidebar/open',
      ),
    close: () =>
      set(
        state => ({
          ...state,
          sidebar: { ...state.sidebar, isOpen: false },
        }),
        false,
        'sidebar/close',
      ),
    setValue: value =>
      set(
        state => ({
          ...state,
          sidebar: { ...state.sidebar, isOpen: value },
        }),
        false,
        'sidebar/setValue',
      ),
  },
});
